import { Box } from "@mui/material";

export const OssDataGridFrame = ({ children, height = 520, sx = {} }) => (
  <Box
    sx={{
      height,
      minHeight: 220,
      width: "100%",
      overflow: "hidden",
      "& .MuiDataGrid-root": {
        border: 0,
      },
      "& .MuiDataGrid-cell": {
        minWidth: 0,
      },
      "& .MuiDataGrid-virtualScroller": {
        scrollbarWidth: "thin",
      },
      "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
        width: 8,
        height: 8,
      },
      "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
        borderRadius: 999,
        backgroundColor: "#cbd5e1",
      },
      "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
        backgroundColor: "#f8fafc",
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);
